var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM4.53 12.274l5.224 5.225 1.305-1.305-1.33-1.33.002-.001-3.895-3.895-1.306 1.306Zm6.304 1.533 1.306 1.306 7.33-7.33-1.306-1.307-7.33 7.33Z",
    fill: "currentColor"
  })));
};

export { SvgCheckCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMjRDMTguNjI3NCAyNCAyNCAxOC42Mjc0IDI0IDEyQzI0IDUuMzcyNTggMTguNjI3NCAwIDEyIDBDNS4zNzI1OCAwIDAgNS4zNzI1OCAwIDEyQzAgMTguNjI3NCA1LjM3MjU4IDI0IDEyIDI0Wk00LjUyOTY5IDEyLjI3MzlMOS43NTQzMiAxNy40OTg2TDExLjA1ODYgMTYuMTk0M0w5LjcyOTI2IDE0Ljg2NDlMOS43MzExIDE0Ljg2M0w1LjgzNTg1IDEwLjk2NzhMNC41Mjk2OSAxMi4yNzM5Wk0xMC44MzM5IDEzLjgwNjdMMTIuMTQwMSAxNS4xMTI4TDE5LjQ3MDMgNy43ODI1OUwxOC4xNjQyIDYuNDc2NDNMMTAuODMzOSAxMy44MDY3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";